import React, { useState, useRef } from "react";

// images from public folder
const Vector = `${process.env.PUBLIC_URL}/assets/Vector.webp`;

const features = [
  {
    id: 0,
    title: "OCR Search",
    description: "Instantly search and find text inside scanned documents and images.",
    gif: "https://i.ibb.co/nNVqN80q/ocr.gif",
  },
  {
    id: 1,
    title: "Business widgets",
    description: "Real-time widgets that allow you to connect your calendar, email and other important integrations.",
    gif: "https://i.ibb.co/ZRLDgGMz/business-widgets.gif",
  },
  {
    id: 2,
    title: "File Locking",
    description: "Prevent unauthorized access by locking critical files securely.",
    gif: "https://i.ibb.co/RkrF4Yxy/File-locking.gif",
  },
  {
    id: 3,
    title: "Password Protection",
    description: "Add an extra layer of security with password-protected documents.",
    gif: "https://i.ibb.co/0y93rjJy/password.gif",
  },
  {
    id: 4,
    title: "Tracking & Audit Trails",
    description: "Monitor every action with detailed logs for complete transparency and control.",
    gif: "https://i.ibb.co/dZrNS3c/audit.gif",
  },
  {
    id: 5,
    title: "Inbuilt Chat Feature",
    description: "Communicate instantly with team members through integrated chat functionality.",
    gif: "https://i.ibb.co/WWkQJP0j/chat.gif",
  },
];

const HomeProduct = () => {
  const [activeFeature, setActiveFeature] = useState(null);
  const cardRefs = useRef([]);

  const handleFeatureClick = (id) => {
    setActiveFeature(id);
    // Scroll to the card
    cardRefs.current[id]?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
    // Auto-remove highlight after 3 seconds
    setTimeout(() => setActiveFeature(null), 3000);
  };

  return (
    <div
      id="product"
      className="bg-[#F1F1FF] h-full w-full px-2 md:px-0 text-[#1C1C1C]"
      style={{
        backgroundImage: `url(${Vector})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "top right",
      }}
    >
      <div className="text-center w-full md:w-2/3 lg:w-3/5 xl:w-1/2 mx-auto py-20 md:py-24 lg:py-28 flex flex-col gap-8">
        <div className="space-y-5">
          <h5 className="text-sm md:text-base font-semibold text-[#5E5ADB] uppercase tracking-wider">
            FEATURES
          </h5>
          <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold font-familjenGrotesk leading-tight">
            <span className="bg-gradient-to-r from-[#7B71E8] from-40% via-[#9B95F0] via-70% to-[#C8C6FF] bg-clip-text text-transparent">
              Unify
            </span>{" "}
            <span className="text-[#1C1C1C]">
              your workspace
            </span>
          </h1>
        </div>
        
        {/* Feature List */}
        <div className="flex flex-wrap justify-center gap-3 md:gap-4 px-4">
          {features.map((feature) => (
            <button
              key={feature.id}
              onClick={() => handleFeatureClick(feature.id)}
              className={`px-4 py-2 md:px-5 md:py-2.5 rounded-full text-sm md:text-base font-semibold transition-all duration-300 ${
                activeFeature === feature.id
                  ? "bg-[#5E5ADB] text-white shadow-lg scale-105"
                  : "bg-white text-[#5E5ADB] hover:bg-[#5E5ADB]/10 border border-[#5E5ADB]/30"
              }`}
            >
              {feature.title}
            </button>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto pb-16 md:pb-20 lg:pb-24 px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              ref={(el) => (cardRefs.current[feature.id] = el)}
              onClick={() => handleFeatureClick(feature.id)}
              className={`bg-white/95 backdrop-blur-sm rounded-2xl p-5 md:p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer group border-2 ${
                activeFeature === feature.id
                  ? "border-[#5E5ADB] shadow-2xl scale-105 ring-4 ring-[#5E5ADB]/30"
                  : "border-[#E5E5FF] hover:border-[#5E5ADB]/40"
              }`}
            >
              <div className="overflow-hidden rounded-xl mb-4 bg-gradient-to-br from-[#F1F1FF] to-[#E8E8FF] p-4">
                <img
                  src={feature.gif}
                  alt={feature.title}
                  className={`h-32 md:h-36 lg:h-40 w-full object-contain transition-transform duration-500 ${
                    activeFeature === feature.id
                      ? "scale-110"
                      : "group-hover:scale-105"
                  }`}
                />
              </div>
              <h4 className={`text-lg md:text-xl font-bold font-familjenGrotesk mb-2 transition-colors ${
                activeFeature === feature.id ? "text-[#5E5ADB]" : "text-[#131149]"
              }`}>
                {feature.title}
              </h4>
              <p className="text-sm md:text-base text-gray-600 font-inter leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeProduct;
